/* eslint-disable */
// this is autogenerated code (we do not care about the linter)

import * as Types from "./types.graphql-gen";

import { gql } from "apollo-angular";
import { Injectable } from "@angular/core";
import * as Apollo from "apollo-angular";
export type CreateOrderMutationVariables = Types.Exact<{
	input: Types.CreateOrderRequest;
}>;

export type CreateOrderMutation = {
	__typename?: "Mutation";
	createOrder:
		| { __typename?: "OrderInProgressResponse"; _?: boolean | null }
		| {
				__typename?: "OrderSuccessResponse";
				order: {
					__typename?: "Order";
					orderId: string;
					status: Types.OrderStatus;
					type: Types.OrderType;
					fiatId: string;
					assetId?: string | null;
					price: { __typename?: "CurrencyAmount"; value: string };
					amount: { __typename?: "CurrencyAmount"; value: string };
					createdAt: { __typename?: "DateTime"; iso8601: string; unixTimestamp: number };
				};
		  };
};

export const CreateOrderDocument = gql`
	mutation createOrder($input: createOrderRequest!) {
		createOrder(request: $input) {
			... on OrderSuccessResponse {
				order {
					orderId
					status
					type
					fiatId
					assetId
					price {
						value
					}
					amount {
						value
					}
					createdAt {
						iso8601
						unixTimestamp
					}
				}
			}
			... on OrderInProgressResponse {
				_
			}
		}
	}
`;

@Injectable({
	providedIn: "root"
})
export class CreateOrderGQLService extends Apollo.Mutation<CreateOrderMutation, CreateOrderMutationVariables> {
	document = CreateOrderDocument;

	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
